
define("placeholder", ["jquery"], function ($) {
    function createLabel(i, ele) {
        var id = ele.id, ph = ele.getAttribute('placeholder');
        if (!$('label[for=' + id + ']').length && ph) {
            // skip if a label already exists or no placeholder text
            $('<label>').text(ph).attr('for', id).insertBefore(ele);
        }
    }

    function process(context) {
        $('input[placeholder], textarea[placeholder]', context || document)
            .not('.input-group *') // ignore elements in input groups
            .each(createLabel);
    }

    if (!('placeholder' in document.createElement('input'))) {
        // browser does not support placeholders
        $(document).ready(function() { process(document); });
    }

    return process;
});